import React from "react";
import { useDeleteExerciseContainerMutation } from "../../libs/exercises/api";
import { ExerciseContainer } from "../../libs/exercises/types";
import { Modal } from "../Modal";

type Props = {
  openModal: string | undefined;
  setOpenModal: (modal: string | undefined) => void;
  container: ExerciseContainer | undefined;
  exercisesCount: number;
  subCount: number;
};

export const DeleteExerciseContainerModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  container,
  exercisesCount,
  subCount,
}) => {
  const [deleteContainer, { isLoading, error }] =
    useDeleteExerciseContainerMutation();

  const handleDelete = (deleteExercises: boolean) => {
    if (!container) return;
    deleteContainer({ id: container.id, deleteExercises })
      .unwrap()
      .then(() => setOpenModal(undefined))
      .catch(() => {});
  };

  if (!container) return null;

  return (
    <Modal
      title={`Elimina: ${container.name}`}
      openModal={
        openModal === "deleteExerciseContainer" ? "deleteExerciseContainer" : undefined
      }
      setOpenModal={setOpenModal}
    >
      <p className="mb-4 text-gray-600 dark:text-gray-300">
        Questa cartella contiene <strong>{exercisesCount}</strong> eserciz{exercisesCount !== 1 ? "i" : "io"}
        {subCount > 0 && (
          <>
            {" "}
            e <strong>{subCount}</strong> sotto-cartell{subCount !== 1 ? "e" : "a"}
          </>
        )}
        . Cosa vuoi fare?
      </p>
      <div className="flex flex-col gap-3">
        <button
          onClick={() => handleDelete(false)}
          disabled={isLoading}
          className="w-full px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg disabled:opacity-50"
        >
          Elimina solo la cartella (gli esercizi tornano alla radice)
        </button>
        <button
          onClick={() => handleDelete(true)}
          disabled={isLoading}
          className="w-full px-4 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg disabled:opacity-50"
        >
          Elimina tutto (cartella + esercizi contenuti)
        </button>
        <button
          onClick={() => setOpenModal(undefined)}
          disabled={isLoading}
          className="w-full px-4 py-2.5 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
        >
          Annulla
        </button>
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600">
          Errore durante l&apos;eliminazione.
        </p>
      )}
    </Modal>
  );
};
